// extracted by mini-css-extract-plugin
module.exports = {"card":"PatientManagerCard_card__1lqx9","name":"PatientManagerCard_name__PMrRx","description":"PatientManagerCard_description__SvANJ"};